import React, { Fragment, useEffect, useState } from "react";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import {
  Chip,
  Collapse,
  IconButton,
  TableCell,
  TableRow,
  Tooltip,
} from "@material-ui/core";
import moment from "moment";
import DetailTest from "../DetailTest/DetailTest";
import { makeStyles } from "@material-ui/styles";
import { StyledTableCell } from "../TestHistory";

const ContentTableTest = ({ row, page }) => {
  const useStyles = makeStyles(() => ({
    tableCell: {
      fontSize: 12,
      textAlign: "center",
    },
  }));
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(false);
  }, [page]);

  return (
    <Fragment>
      <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
        <StyledTableCell align="center" className={classes.tableCell}>
          {row.id}
        </StyledTableCell>
        <StyledTableCell
          style={{ color: "#8f7bff", fontSize: 15, textAlign: "left" }}
          className={classes.tableCell}
        >
          {row.farm.name}
        </StyledTableCell>
        <StyledTableCell
          className={classes.tableCell}
          style={{ textAlign: "left" }}
        >
          {row.farm.address}
        </StyledTableCell>
        <StyledTableCell
          className={classes.tableCell}
          style={{ textAlign: "left" }}
        >
          {row.farm.province}
        </StyledTableCell>
        <StyledTableCell className={classes.tableCell}>
          {row.testType === "General"
            ? "ATSH toàn trại"
            : row.testType === "Outside"
            ? "ATSH bên ngoài"
            : "ATSH bên trong"}
        </StyledTableCell>
        <StyledTableCell className={classes.tableCell}>
          {moment(row.createTime).format("DD/MM/YYYY")}
        </StyledTableCell>
        <StyledTableCell className={classes.tableCell}>
          {row.sowsNo}
        </StyledTableCell>
        <StyledTableCell className={classes.tableCell}>
          {row.sucklingPiglets}
        </StyledTableCell>
        <StyledTableCell className={classes.tableCell}>
          {row.boars}
        </StyledTableCell>
        <StyledTableCell className={classes.tableCell}>
          {row.finishingPigs}
        </StyledTableCell>
        <StyledTableCell className={classes.tableCell}>
          {row.nurseyPigs}
        </StyledTableCell>
        <StyledTableCell className={classes.tableCell}>
          <Tooltip title="Điểm đánh giá">
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </Tooltip>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <DetailTest id={row.id} />
          </Collapse>
        </TableCell>
      </TableRow>
    </Fragment>
  );
};

export default ContentTableTest;
